import styled from "styled-components";
export const InputContainer = styled.div`
  width: 100%;
  label {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .input-area {
    width: 100%;
    position: relative;
    input {
      background-color: ${({ theme }) => theme.colors.background};
      border-radius: 5px;
      border: solid 1px ${({ theme }) => theme.colors.inputBorder};
      border-color: ${({ error, theme }) =>
        error ? "red" : theme.colors.inputBorder};
      padding: 10px 8px 0px 8px;
      font-size: ${({ theme }) => theme.sizes.font2};
      width: 100%;
      direction: ${({ ltr }) => (ltr ? "ltr" : "rtl")};
      ${(props) => {
        if (props.icon && props.ltr) {
          return `
            padding-left: 36px;
          `;
        } else if (props.icon) {
          return `
            padding-right: 36px;
          `;
        }
      }}
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        display: none;
      }
    }
    svg,.icon {
      position: absolute;
      position: absolute;
      font-size: 24px;
      top: 10px;
      ${(props) => {
        if (props.ltr) {
          return `
            left: 8px;
          `;
        } else {
          return `
            right: 8px;
          `;
        }
      }}
      color: ${({ theme }) => theme.colors.inputBorder};
    }
    .error {
      position: absolute;
      right: 0;
      color: red;
      font-size: 8px;
      bottom: 0;
      padding: 0 4px;
      background: #fff;
      margin: 1px;
      border-radius: 4px;
      line-height: 9px;
    }
    ${({ required }) =>
      required
        ? `
    &:before {
      background: red;
      width: 5px;
      height: 5px;
      content: "";
      position: absolute;
      top: 3px;
      border-radius: 3px;
      right: 3px;
      z-index: 1;
    }`
        : ""})};
  }
  @media only screen and (max-width: 760px) {
    .input-area {
      input {
        padding: 8px 8px 0px 8px;
        font-size: 20px;
        ${(props) => {
          if (props.icon && props.ltr) {
            return `
              padding-left: 36px;
            `;
          } else if (props.icon) {
            return `
              padding-right: 36px;
            `;
          }
        }}
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
          display: none;
        }
      }
      svg {
        position: absolute;
        position: absolute;
        font-size: 22px;
        top: 10px;
        ${(props) => {
          if (props.ltr) {
            return `
              left: 8px;
            `;
          } else {
            return `
              right: 8px;
            `;
          }
        }}
        color: ${({ theme }) => theme.colors.inputBorder};
      }
      .error {
        position: absolute;
        right: 0;
        color: red;
        font-size: 8px;
        bottom: 0;
        padding: 0 4px;
        background: #fff;
        margin: 1px;
        border-radius: 4px;
        line-height: 9px;
      }
      ${({ required }) =>
        required
          ? `
      &:before {
        background: red;
        width: 5px;
        height: 5px;
        content: "";
        position: absolute;
        top: 3px;
        border-radius: 3px;
        right: 3px;
        z-index: 1;
      }`
          : ""})};
    }
  }
`;
